import React from 'react';
import { Box, Image, Text } from '@chakra-ui/react';
import './AuthLogo.scss';
import authLogo from '/assets/images/logos/auth-logo.svg';

const AuthLogo: React.FC = () => {
  return (
    <Box textAlign="center" className="auth-logo">
      <Image src={authLogo} alt="Alea Logo" mb={2} width={225} margin="auto" />
      <Text
        width={225}
        fontWeight={300}
        fontSize={14.75}
        mt={15}
        textAlign="left"
        lineHeight={1.3}
        letterSpacing={'-0.1px'}
        color={'#000'}
        marginLeft="auto"
        marginRight="auto"
      >
        Sensorbasiertes Inkontinenz-
        {'\n'}und Bewegungsmonitoring
      </Text>
    </Box>
  );
};

export default AuthLogo;
